import Section from "@/components/Section";
import { Grid, Typography } from "@mui/material";

import { benefits } from "@/utils/staticData/fleetInquiry";
import BenefitCard from "./BenefitCard";

const Benefits = () => {
  return (
    <Section pt={{ xs: 0, md: 8, lg: 12.5 }} pb={{ xs: 7.5, md: 8, lg: 12.5 }}>
      <Typography
        variant="h2"
        mb={{ xs: 2, md: 3 }}
        textAlign={{ xs: "start", md: "center" }}
      >
        Benefits
      </Typography>

      <Grid container spacing={{ xs: 3, lg: 4 }}>
        {benefits.map(({ title, iconUrl }, index) => (
          <Grid item xs={12} sm={6} lg={3} key={index}>
            <BenefitCard title={title} iconUrl={iconUrl} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default Benefits;
